export const logoAnimation = {
  hidden: {
    width: 0,
    padding: 0,
    opacity: 0,
  },
  show: {
    width: '100%',
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
};

export const showAnimation = {
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
  show: {
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
};
